import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';

const BatchTaskList = ({ token, setError, setSuccess }) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  // 获取任务列表
  const fetchTasks = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/scripts/batch-tasks`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('获取任务列表失败');
      }
      
      const data = await response.json();
      setTasks(data.tasks || []);
    } catch (err) {
      setError('获取任务列表失败: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 查询任务状态
  const checkTaskStatus = async (taskId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/scripts/batch-import-status/${taskId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('获取任务状态失败');
      }
      
      const data = await response.json();
      return data;
    } catch (err) {
      setError('获取任务状态失败: ' + err.message);
      return null;
    }
  };

  // 下载结果文件
  const downloadResult = (taskId, type) => {
    const element = document.createElement('a');
    const file = new Blob([`下载任务 ${taskId} 的 ${type} 文件`], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = `${taskId}_${type}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  // 刷新任务列表
  const refreshTasks = () => {
    setLoading(true);
    fetchTasks();
  };

  // 组件挂载时获取任务列表
  useEffect(() => {
    fetchTasks();
    // 每30秒自动刷新一次
    const interval = setInterval(fetchTasks, 30000);
    return () => clearInterval(interval);
  }, [token]);

  if (loading) {
    return <div className="batch-task-list">加载中...</div>;
  }

  return (
    <div className="batch-task-list">
      <div className="batch-task-header">
        <h2>批量任务列表</h2>
        <button onClick={refreshTasks} className="refresh-button">刷新</button>
      </div>
      
      {tasks.length === 0 ? (
        <div className="no-tasks">暂无批量任务</div>
      ) : (
        <div className="tasks-container">
          {tasks.map(task => (
            <div key={task.id} className="task-item">
              <div className="task-info">
                <div className="task-id">任务ID: {task.id}</div>
                <div className="task-status">
                  状态: 
                  <span className={`status-${task.status}`}>
                    {task.status === 'processing' && '处理中'}
                    {task.status === 'completed' && '已完成'}
                    {task.status === 'failed' && '失败'}
                  </span>
                </div>
                {task.status === 'processing' && (
                  <div className="task-progress">
                    进度: {task.progress || 0}%
                  </div>
                )}
                <div className="task-created">
                  创建时间: {new Date(task.created_at).toLocaleString()}
                </div>
              </div>
              
              <div className="task-actions">
                {task.status === 'completed' && (
                  <>
                    <button 
                      onClick={() => downloadResult(task.id, 'result')}
                      className="download-button"
                    >
                      下载结果
                    </button>
                    <button 
                      onClick={() => downloadResult(task.id, 'password')}
                      className="download-button"
                    >
                      下载密码
                    </button>
                  </>
                )}
                {task.status === 'failed' && (
                  <button 
                    onClick={() => checkTaskStatus(task.id)}
                    className="retry-button"
                  >
                    重试
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BatchTaskList;